import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import swal from 'sweetalert';
import * as MenuAction from './MenuAction';
const GetMMReceivingPageLoad = (MMReceivingPageLoadBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Receiving,
            SDIConstants.methodNames.ReceivingPageLoad,
            JSON.stringify(MMReceivingPageLoadBO),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReceivingPageLoad, response: data.response };
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
//[3/2/2023]PC_02_597 Delivery Ticket For receive Items-Pavithra R
const deliveryTicketPdf = (DeliveryTicketBO) => {
    try {
        ;
        SDISVC.receiveFileBase64(
            SDIConstants.moduleNames.Receive_Item,
            SDIConstants.methodNames.delivery_Ticket_Pdf,
            JSON.stringify(DeliveryTicketBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "DeliveryPDF", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();


                        }
                        if (data.response.status = "500") {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Error in generating Report"
                            });
                            $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        }
                    }
                }

            });
    } catch (ex) {
        console.log(ex)
    }
}


const MMReceivingPODetail = (MMReceivingPODetailBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Receiving,
            SDIConstants.methodNames.getPODetails,
            JSON.stringify(MMReceivingPODetailBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.getPODetails, response: data.response };
                        Dispatcher.dispatch(contentData);
                    } else {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "PO is invalid"
                        });

                        // alert("PO is invalid");
                    }
                }
                else if (data.success == false) {

                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}



const SubmitReceiving = async (SubmitReceivingPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Receiving,
            SDIConstants.methodNames.submitReceiving,
            JSON.stringify(SubmitReceivingPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = {
                            type: SDIConstants.methodNames.submitReceiving, response: data.response
                        };
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        Dispatcher.dispatch(contentData);

                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const getPassThroughAutheURl = (getPassThroughAutheURlBO) => {
    try {
        //
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.PassThroughAuthe,
            SDIConstants.methodNames.PassThroughAuthe_PassAutheInitialize,
            JSON.stringify(getPassThroughAutheURlBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PassThroughAuthe", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {

                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

export {
    getPassThroughAutheURl, GetMMReceivingPageLoad, SubmitReceiving, MMReceivingPODetail, insertFavPage, deleteFavPage, getCurrentFavPage, deliveryTicketPdf
}